import styled from 'styled-components'

export const ReadMoreContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`

export const Heading = styled.h1`
  font-family: 'Roboto';
  color: #1e293b;
  font-size: 30px;
  margin-bottom: 0px;
  font-weight: 900;
`
export const HeadDescribe = styled.p`
  font-family: 'Roboto';
  color: #1e293b;
  font-size: 20px;
  font-weight: 500;
`

export const MainContainer = styled.div`
  width: 700px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`
export const ReactImage = styled.img`
  height: 400px;
  width: 100%;
`
export const Paragraph = styled.p`
  font-family: 'Roboto';
  color: #1e293b;
  font-size: 18px;
  font-weight: 500;
`
export const Button = styled.button`
  font-family: 'Roboto';
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
  background-color: #1f81ff;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 10px;
  padding: 10px 30px;
  @media screen and (max-width: 767px) {
    align-self: flex-start;
  }
`
